import Vue from "vue";
import moment from "moment";

export default {
  currency: Vue.filter("currency", function (value) {
    return value && Number(value.toFixed(1)).toLocaleString();
  }),
  uppercase: Vue.filter("uppercase", function (value) {
    return value && value.toUpperCase();
  }),
  formatDate: Vue.filter("formatDate", function (value) {
    if (value) {
      return moment(value).format("DD/MM/YYYY");
    }
    return "";
  }),
  formatTime: Vue.filter("formatTime", function (value) {
    if (value) {
      return moment(value).format("HH:mm");
    }
    return "";
  }),
  formatDateHour: Vue.filter("formatDateHour", function (value) {
    if (!value) return "";
    return moment(value).format("DD/MM/YYYY HH:mm");
  }),
  formatDateCustom: Vue.filter("formatDateCustom", function (value, custom) {
    if (!value) return "";
    return custom
      ? moment(value).format(custom)
      : moment(value).format("DD/MM/YYYY");
  }),
  numParseFloat: Vue.filter("numParseFloat", function (number, toNumber) {
    if (!number || !+number || +number === 0) {
      return 0;
    } else {
      let numCompare = 1;
      for (let i = 0; i < toNumber; i++) {
        numCompare += "0";
      }
      if ((number * +numCompare) % 1 !== 0) {
        return number.toFixed(toNumber);
      } else {
        return number;
      }
    }
  }),
};
